import { Redirect, useParams } from 'react-router-dom';
import React from 'react';
import PreApptLandingPage from '../PreApptLandingPage';
import { resolvePreApptRedirectPath } from '../../../utils/preApptRedirectUtils';

const PreApptWrapper = ({ workflow }) => {
  const { workflowId } = useParams();
  const redirectPath = resolvePreApptRedirectPath(workflowId, workflow);

  if (redirectPath) {
    return <Redirect to={redirectPath} />;
  }

  return <PreApptLandingPage workflow={workflow} />;
};

export default PreApptWrapper;
